"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSortable = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _TableSortable = require("./TableSortable.context");
/**
 * `Table.Sortable` is an HOC that can be used to create a `Table` with sortable columns.
 *
 * `Table.Sortable` is essentially a controlled component but does offer some uncontrolled
 * functionality. When a user clicks on a `Table.SortableHeaderCell`,
 * `Table.Sortable` determines which arrow icons to display across all column headers.
 * However, `Table.Sortable` does not actually sort the table data. Sorting is handled
 * by your own functions or API calls.
 *
 * @subcomponents ['Table.SortableHeaderCell']
 * @since 8.41.0
 */
var TableSortable = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _useState = (0, _react.useState)(props.defaultSortDirections),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    directions = _useState2[0],
    setDirections = _useState2[1];
  return /*#__PURE__*/_react.default.createElement(_TableSortable.TableSortableProvider, (0, _extends2.default)({
    value: {
      directions: directions,
      setDirections: setDirections,
      onSortChange: props.onSortChange
    },
    ref: forwardedRef
  }, props));
});
exports.TableSortable = TableSortable;
TableSortable.displayName = 'Table.Sortable';
TableSortable.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Callback passed to every sortable header cell. Fired on click or keypress.
   * A `Table.SortableHeaderCell`
   * can also use their own `onSortChange` callback to override.
   *
   * Takes two arguments: an object `{currentSortDirection, nextSortDirection}` and `props`
   */
  onSortChange: _propTypes.default.func,
  /**
   * Sets the initial sort direction for each column.
   * Ex: `['ascending', 'none', 'none']`.
   *
   * Use `null` for non-sortable columns.
   */
  defaultSortDirections: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
} : {};
TableSortable.defaultProps = {
  onSortChange: function onSortChange() {}
};